export { FileUploaderModule } from "./file-uploader.module";
export { FileUploaderComponent } from "./fileuploader.component";